import StrategicIssue from "./Sections/StrategicIssue"

const SIssue = () => (
    <>
        <StrategicIssue/>
    </>
)

export default SIssue